import * as React from "react";
const SvgBanquetServer = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 60, height: 51, viewBox: "0 0 60 51", fill: "none", ...props }, "...");
export default SvgBanquetServer;
